export const environment = {
  production: true,
  apiUrl: 'https://ca-goldexperts-api-dev.whitedesert-5e7a310f.westeurope.azurecontainerapps.io/api',
  demoMode: true,
};
